module.exports = __webpack_public_path__ + "img/item_mi_adv.ec842fa3.jpg";